import React from 'react';
import styled from 'styled-components';
import { motion, Variants } from 'framer-motion';
import { Rocket } from 'lucide-react';
import { colors } from '../styles/colors';
import { typography } from '../styles/typography';
import { spacing } from '../styles/spacing';

const ComingSoonContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background: ${colors.background.primary};
  padding: ${spacing[4]};
`;

const IconWrapper = styled(motion.div)`
  margin-bottom: ${spacing[6]};
`;

const Title = styled(motion.h1)`
  font-family: ${typography.fonts.primary};
  font-size: ${typography.sizes['3xl']};
  font-weight: ${typography.weights.bold};
  color: ${colors.text.primary};
  margin-bottom: ${spacing[2]};
`;

const Subtitle = styled(motion.p)`
  font-family: ${typography.fonts.primary};
  font-size: ${typography.sizes.lg};
  color: ${colors.text.secondary};
  max-width: 400px;
`;

const ComingSoon: React.FC = () => {
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <ComingSoonContainer
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <IconWrapper
        variants={itemVariants}
        animate={{
          scale: [1, 1.1, 1],
          rotate: [0, 10, -10, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut',
        }}
      >
        <Rocket size={64} color={colors.primary.DEFAULT} />
      </IconWrapper>
      <Title variants={itemVariants}>Coming Soon!</Title>
      <Subtitle variants={itemVariants}>
        I'm still figuring this one out Chiko, but you'll like it when its
        ready. Stay tuned 😂
      </Subtitle>
    </ComingSoonContainer>
  );
};

export default ComingSoon;
